import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";

const promptResponsesReducer = createAsyncReducer({
    name: 'promptResponses',
    initialState: {
        records: {},
        loading: false,
        errorMessage: ''
    },
    reducers: (create) => ({
        savePromptResponses: create.asyncThunk(
            async ({ promptResponses }) => {
                return Fetch.post(Routes.ajax_prompt_responses_path(), { body: { prompt_responses: promptResponses } });
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    state.loading = false;
                    state.errorMessage = action.error;
                }
            }
        )
    })
});

export default promptResponsesReducer;